import { useState } from 'react'
import { Icon } from './Layout'

const POINTS = [
  {
    icon: 'trending_up',
    text: 'Your CIS balance determines your level, and your level sets the CPT reward multiplier you earn on tasks, campaigns, and offers.',
  },
  {
    icon: 'tune',
    text: 'The CIS → CPT conversion rate is not fixed. It changes based on total CIS held platform-wide, CIS earned in the period, platform revenue, and available reward funds.',
  },
  {
    icon: 'event',
    text: 'You can\u2019t convert CIS to CPT whenever you want — conversion only opens during specific periods announced by the team.',
  },
  {
    icon: 'remove_circle',
    text: 'Any CIS you convert is deducted from your balance. It doesn\u2019t just sit there as a permanent score.',
  },
  {
    icon: 'trending_down',
    text: 'Converting a large amount of CIS can drop your balance below your current level\u2019s threshold — lowering your level and your reward multiplier.',
  },
]

export default function CisCptExplainer({ defaultOpen = false, className = '' }) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className={`border-2 border-on-background/15 bg-surface-container ${className}`}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-2 px-4 py-3 text-left"
      >
        <span className="flex items-center gap-2 font-extrabold text-[12px] uppercase tracking-widest">
          <Icon name="info" className="text-[16px] text-primary-container" />
          How CIS → CPT works
        </span>
        <Icon name={open ? 'expand_less' : 'expand_more'} className="text-[18px] opacity-60" />
      </button>

      {open && (
        <div className="px-4 pb-4 flex flex-col gap-3">
          {POINTS.map((p, i) => (
            <div key={i} className="flex items-start gap-2.5">
              <Icon name={p.icon} className="text-[16px] text-primary-container mt-0.5 shrink-0" />
              <p className="text-[11px] leading-snug text-on-surface-variant">{p.text}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}